/*!*
 * @author yueheqin
 * @date 2019/7/4
 * @project zujuanzaixian
 * @desc
 */

import { hasPaperData } from '../views/utils/has-paper-data'
import { removeLocalItem, setLocalItem } from '../utils/storage'

let xtRE = /(【小题】)/g
let thRE = /(【题号】)/g

/**
 * @desc 计算试题列表中的题号
 * @todo 该方法有待测试和优化 英语题号有问题，跳转也有问题 eg/paperdetail?prePage=mxmj&docID=71242    71-80
 * @params list [array] testList
 */

export function countTestListOrder (list) {
  // console.log(list)
  let currentOrder = 0
  let copied = JSON.parse(JSON.stringify(list))
  _.each(copied, (item) => {
    if (item == null) return
    item._order = []
    let rIndex = -1
    // 如果没有【题号】和【小题】标记
    if (!xtRE.test(item.test) && !thRE.test(item.test) && !/<strong role="order"/.test(item.test)) {
      currentOrder++
      item.test = `<span style="float: left; margin-right: 10px;"><strong role="order" id="question-order-${currentOrder}">${currentOrder}.</strong>` +
        (item._sameScore ? '' : Array.isArray(item.score) && item.score.length ? `<span style="margin-left: 10px;" class="text-primary">(本题${Number(item.score[0])}分)</span>` : '') + `</span>${item.test}`
      return
    }

    let temp = currentOrder
    // 替换 【小题】
    if (xtRE.test(item.test)) {
      let subIndex = -1
      item.test = item.test.replace(xtRE, () => {
        subIndex++
        currentOrder++
        item._order.push(currentOrder)
        if (currentOrder == 41) {
          // console.log(item.test)
        }
        return `<span style="float: left;"><strong role="order" id="question-order-${currentOrder}"> ${currentOrder}.</strong>` +
          (item._sameScore ? '' : Array.isArray(item.score) && item.score.length ? `<span style="margin-left: 10px;" class="text-primary">(本题${item.score[subIndex]}分)</span>` : '') + '</span>'
      })
    }
    if (xtRE.test(item.answer)) {
      currentOrder = temp
      item.answer = item.answer.replace(xtRE, () => {
        currentOrder++
        item._order.push(currentOrder)
        return `<strong> ${currentOrder}.</strong>`
      })
    }
    if (xtRE.test(item.analytic)) {
      currentOrder = temp
      item.analytic = item.analytic.replace(xtRE, () => {
        currentOrder++
        item._order.push(currentOrder)
        return `<strong> ${currentOrder}.</strong>`
      })
    }

    // // 替换 【题号】
    if (thRE.test(item.test)) {
      rIndex = -1
      if (!/question-order-/.test(item.test)) {
        item.test = `<strong role="order" id="question-order-${item._order[rIndex + 1] || currentOrder + 1}"></strong>` + item.test
      }
      item.test = item.test.replace(thRE, () => {
        rIndex++
        let order = item._order[rIndex] || currentOrder++
        return `<strong> ${order} </strong>`
      })
    }
  })
  return copied
}

export const getTmpPaperCallbackMixin = {
  methods: {
    getTmpPaperCallback ({ noTmp, cancel, cancelButtonText } = {}) {
      let vm = this
      vm.getTmpPaper((data) => {
        // console.log(data)
        let hasTmp = hasPaperData(data.paper.typeCompose)
        if (!hasTmp || data.saved == 1) {
          _.isFunction(noTmp) && noTmp()
          return
        }
        vm.$MsgBox({
          title: '提示',
          type: 'confirm',
          icon: 'warning',
          cancelButtonText: cancelButtonText || '取消',
          // cancelButtonText: cancelButtonText || '取消(删除)',
          // message: '你有试卷未保存，是否继续上次操作？',
          message: '你有试卷未保存，取消则放弃试卷，确定则查看试卷',
          callbackClose: true,
          callback (type, close) {
            // 取消使用上次数据，并删除远端和本地数据
            if (type === 'cancel') {
              _.each(data.paper.typeCompose, item => {
                item.sub = []
              })
              vm.saveTmpPaper(data.paper)
              removeLocalItem('paper_data')
              _.isFunction(cancel) && cancel()
            }
            if (type === 'confirm') {
              setLocalItem('paper_data', data)
              vm.$router.push({ name: 'PaperView', query: { useLocal: '1' } })
              close()
            }
          }
        })
      })
    }
  }
}

export const paperAnalysisMixin = {
  data () {
    return {
      paperAnalysisData: {
        typeChartData: {
          testNum: 0,
          seriesData: []
        },
        diffChartData: {
          avgDiff: 0,
          seriesData: []
        },
        klTableData: {
          tableData: [],
          klDataLength: 0
        }
      }
    }
  },
  methods: {
    bindPaperAnalysis (testList) {
      if (!_.isArray(testList)) {
        console.error(testList, 'is not array')
        return
      }
      let testNum = _.reduce(_.map(testList, item => Number(item.testNum)), (a, b) => a + b)
      let tempData = _.map(testList || this.testList, item => {
        return {
          diff: item.diff,
          diffName: item.diffName,
          typesID: item.typesID,
          typesName: item.typesName,
          testNum: item.testNum,
          totalDiff: (item.diff - 0) * (item.testNum - 0) // 本道题总难度（复合题是几道题总和）
        }
      })
      // 题型统计图表数据
      let typeArrMap = _.groupBy(tempData, 'typesID')
      this.paperAnalysisData.typeChartData.seriesData = _.map(typeArrMap, (value, key) => {
        let num = 0
        let name = ''
        _.each(value, i => {
          num += i.testNum
          name = i.typesName
        })
        let rate = _.round(num / (testNum - 0) * 100, 2)
        return {
          value: rate,
          name: name + '(' + rate + '%)'
        }
      })
      this.paperAnalysisData.typeChartData.testNum = testNum

      let diffArrMap = _.groupBy(tempData, 'diffName')
      let diffData = _.map(diffArrMap, (value, key) => {
        let num = 0
        let total = 0
        _.each(value, i => {
          num += i.testNum
          total += i.totalDiff
        })
        let rate = _.round(num / (testNum - 0) * 100, 2)
        return {
          rate: rate,
          name: key + '(' + rate + '%)',
          totalDiff: total
        }
      })
      this.paperAnalysisData.diffChartData.avgDiff = this.getAvgDiff(testList)

      this.paperAnalysisData.diffChartData.seriesData = _.map(diffData, item => {
        return {
          value: item.rate,
          name: item.name
        }
      })
      // 知识点统计图表
      let queNum = 0
      let klTotalList = []
      this.paperAnalysisData.klTableData.tableData = _.each(testList, item => {
        item.queNum = item.testNum > 1 ? (queNum + 1) + '-' + (queNum + item.testNum) : queNum + 1
        queNum += item.testNum
        klTotalList = _.concat(klTotalList, item.klList)
      })
      this.paperAnalysisData.klTableData.klDataLength = _.uniq(klTotalList).length
      this.$refs.paperAnalysisDialog.open()
    },
    // 计算总难度   假如有5道题，分别为 第一题5分难度0.8，第二题10分难度0.5，第三题15分难度0.2，第四题10分难度0.4，第五题10分难度0.6，其中第四题和第五题是一组选做题2选1， 则难度计算公式为
    // （5×0.8+10×0.5+15×0.2+(10×1/2)×0.4+(10×1/2)×0.6）/（5+10+15+(10×1/2)+(10×1/2)）= 0.425
    getAvgDiff (list) {
      let totalScore = 0
      let totalDiff = 0
      let chooseGroupGroup = _.groupBy(list, 'chooseGroup')
      let chooseGroupGroupMap = {}
      _.each(chooseGroupGroup, item => {
        chooseGroupGroupMap[item[0].chooseGroup] = item.length
      })
      _.each(list, item => {
        // 非选做题
        let score = _.sumBy(item.score, Number)
        if (Number(item.chooseGroup) == 0) {
          totalScore += score
          totalDiff += Number(item.diff) * score
        } else { // 选做题
          let group = item.chooseGroup
          totalScore += score / chooseGroupGroupMap[group]
          totalDiff += Number(item.diff) * score / chooseGroupGroupMap[group]
        }
      })
      return _.round(totalDiff / totalScore, 3)
    },
    download (url) {
      let iframe = document.getElementById('#downloadIframe')
      if (iframe) {
        iframe.src = url
      } else {
        iframe = document.createElement('iframe')
        iframe.id = '#downloadIframe'
        iframe.style.display = 'none'
        iframe.src = url
        document.body.appendChild(iframe)
      }
    }
  }
}
